import React from 'react';
import { useFormikContext } from 'formik';
import { Gap } from 'lib/components/styles/layout';
import { Heading } from 'lib/components/styles/typography';
import { useAuth } from 'lib/context';

import { Button } from 'react-covideo-common';
import { MdDeleteForever, MdEmail, MdSave } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components/macro';
import { useCDK } from 'lib/hooks/useCdk';

interface IDetailsPreviewHeaderProps {
  setContinueToSendShare: React.Dispatch<React.SetStateAction<boolean>>;
  onDiscardHandler: () => void;
}
export const DetailsPreviewHeader = ({
  setContinueToSendShare,
  onDiscardHandler,
}: IDetailsPreviewHeaderProps) => {
  const { t } = useTranslation();
  const { isValid, submitForm } = useFormikContext();
  const { userData } = useAuth();
  const { colors } = useTheme();
  const { destructiveToText, secondaryToPrimary } = useCDK();

  const handleContinueToSendShare = () => {
    setContinueToSendShare(true);
    submitForm();
  };
  return (
    <>
      <Gap width='100%' justifyContent='space-between' m='0 0 32px 0'>
        <Heading color={colors.black[100]}>
          {t('Preview recorded video')}
        </Heading>
        <Gap gap='8px'>
          <Button
            icon={<MdDeleteForever size={20} />}
            text={t('Discard')}
            variant={destructiveToText}
            onClick={onDiscardHandler}
          />
          <Button
            disabled={!isValid}
            icon={<MdSave size={18} />}
            text={
              userData.isAutomotiveSalesRole ? t('Save') : t('Save Recording')
            }
            onClick={submitForm}
            variant={secondaryToPrimary}
          />

          {userData.isAutomotiveSalesRole && (
            <Button
              variant='primary'
              disabled={!isValid}
              icon={<MdEmail size={20} />}
              text={t('Continue to Send & Share')}
              onClick={handleContinueToSendShare}
            />
          )}
        </Gap>
      </Gap>
    </>
  );
};
